import React, { useRef, useState } from 'react';
import { Initials } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import { ellipsis } from '@fabric-ui/utils';
import { Box, Button, Popover, useTheme } from '@mui/material';

const numOfInitials = 2;

const wrapperStyle = {
  minHeight: 32,
  display: 'contents',
  '> span:first-of-type': {
    lineHeight: '32px',
    alignSelf: 'start',
    flexShrink: 0,
  },
  '> *': {
    ...flex.itemsCenter,
  },
  a: {
    textDecoration: 'none',
  },
};
export interface AvInitialsListProps {
  items: string[];
}

export const AvInitialsList: React.FC<AvInitialsListProps> = ({ items }) => {
  const theme = useTheme() as any;
  const sx = {
    ...flex.row,
    ...ellipsis,
    WebkitLineClamp: '1',
    columnGap: 1,
    rowGap: '3px',
    '.extra-items': {
      height: 20,
      padding: '1px 7px',
      backgroundColor: theme.palette.colors.neutrals[350],
      border: 0,
      borderRadius: '8px',
      fontSize: 13,
      fontWeight: 500,
      '&:hover': {
        backgroundColor: theme.palette.colors.neutrals[350],
        border: 0,
        borderRadius: '8px',
      },
    },
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef(null);

  const handleClick = () => setAnchorEl(buttonRef.current);
  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);
  const generateInitial = (name, i = 0) => (
    <div key={i} style={{ marginLeft: `-${i * 18}px` }}>
      <Initials name={name} size="small" />
    </div>
  );

  const paperStyle = {
    ...flex.col,
    gap: 2,
    pl: 1,
    py: 2,
    pr: 4,
    backgroundColor: theme.palette.white.main,
    minWidth: 'fit-content',
  };

  return (
    <Box sx={wrapperStyle}>
      <Box sx={sx}>
        {items.slice(0, numOfInitials).map((label, i) => generateInitial(label, i))}
        {numOfInitials < items.length && (
          <>
            <Button ref={buttonRef} variant="outlined" className="extra-items" onMouseEnter={handleClick} onMouseLeave={handleClose}>
              +{items.length - numOfInitials}
            </Button>
            <Popover
              onClick={e => e.stopPropagation()}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              PaperProps={{ sx: paperStyle }}
              sx={{ pointerEvents: 'none', ml: 2 }}
              anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
              transformOrigin={{ vertical: 'center', horizontal: 'left' }}>
              {items.slice(numOfInitials).map(name => generateInitial(name))}
            </Popover>
          </>
        )}
      </Box>
    </Box>
  );
};
